const datePickerOptions = {
  enableTime: true,
  dateFormat: "DD/MM/YYYY HH:mm",
  placeholder: "dd/mm/yyyy hh:mm",
  drops: "up",
};

export default {
  excludeFrom: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
  excludeTo: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
  "ui:order": ["absenceReason", "excludeFrom", "excludeTo"],
};
